import { ROLES_KEYS } from 'config';
import getUserRole from '../jwt/getUserRole';

const checkAccess = (accessKeys = []) => {
  const currentRole = getUserRole();
  let avaible = false;
  accessKeys.forEach((key) => {
    if (ROLES_KEYS[currentRole] === key) {
      avaible = true;
    }
  });

  return avaible;
};

export default checkAccess;
